import BaseScreen from "./BaseScreen";
import NavBar from "../components/NavBar";
import React, { useEffect, useState } from "react";
import { useIsFocused } from "@react-navigation/native";
import { FlatList, Image, Pressable, Text, View } from "react-native";
import globalEventBus from "../utils/EventBus";
import { color_333333, color_999999, color_F1F1F1, white } from "../assets/style/colors";
import { noticeList, noticeModify } from "../net/service";
import { SystemNotice } from "../net/response";
import { ListEmpty } from "../components/ListEmpty";
import { MainNavProps } from "./navigation/main/MainParamList";
import { Str_Notice } from "../language/string_res";

export const Announcement = ({ navigation }: MainNavProps<'Announcement'>) => {
    const isFocused = useIsFocused();
    const [data, setData] = useState<SystemNotice[]>()
    useEffect(() => {
        if (isFocused) {
            noticeList().then((res) => {
                if (res.code === 0 && res.data) {
                    setData(res.data.notices)
                }
            })
        }
    }, [isFocused]);

    function clickItem(item: SystemNotice) {
        noticeModify(item.noticeId).then()
        if (item.href.length > 0 && (!item.content || item.content.length === 0)) {
           navigation.navigate("CommonWeb", { url: item.href })
        } else {
           navigation.navigate("AnnouncementDetail", { title: item.title, content: item.content, url: item.href })
        }
    }

    function renderItem({ item }: { item: SystemNotice }) {
        return (<Pressable
            onPress={() => clickItem(item)}
            style={{
                flexDirection: 'row',
                height: 60,
                paddingHorizontal: 17,
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
            <View
                style={{
                    justifyContent: 'center',
                    flex: 1,
                    flexDirection: 'column',
                }}>
                <Text
                    numberOfLines={1}
                    ellipsizeMode={'tail'}
                    style={{ color: color_333333, fontSize: 17, }}>{item.title}
                </Text>
                <Text
                    numberOfLines={1}
                    ellipsizeMode={'tail'}
                    style={{ color: color_999999, fontSize: 14, }}>{item.content}
                </Text>
            </View>

            <Image source={require("../assets/image/icon_right_arrow.png")} />
            <View
                style={{ backgroundColor: color_F1F1F1, height: 1, position: 'absolute', bottom: 0, start: 0, end: 0 }} />
        </Pressable>)
    }

    return (<BaseScreen>
        <NavBar title={Str_Notice} showBack={false} />
        <View style={{
            borderRadius: 8, borderRightWidth: 1,
            marginTop: 10,
            height: data ? data.length * 60 : 200,
            marginHorizontal: 10,
            borderRightColor: color_F1F1F1, backgroundColor: white
        }}>
            {data && data.length > 0 ? <FlatList
                data={data}
                keyExtractor={(item) => item.noticeId.toString()}
                renderItem={renderItem}
            /> : <ListEmpty />}
        </View>
    </BaseScreen>)
}
